import React from "react";
import DesignForm from "./DesignForm";

/**
 * Thin mode wrapper around the shared DesignForm (SCRUM-903).
 * SCRUM-1814: `switchToDesignListHandler` is where Restore lands — the list
 * card, which now shows the restored design.
 */
type AddDesignProps = {
  switchToDesignListHandler?: () => void;
};

const AddDesign = (props: AddDesignProps) => (
  <DesignForm
    mode="add"
    switchToDesignListHandler={props.switchToDesignListHandler}
  />
);

export default AddDesign;
